import React from 'react'
import styled from "styled-components";
import { THEME } from 'Util/constants';
import { FilterFilled } from '@ant-design/icons';
import CommonExportIcon from 'Components/CommonExportIcon'
import ActionDropdown from './ActionDropdown';

const Container = styled.div`
    width: 80px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .anticon{
        color: ${THEME.colors.primary};
        cursor: pointer;
    }
    
    svg{
        cursor: pointer;
    }
`;

function ExtraFilters(props) {
    const {data, column, isBulk, disabled, onSubmit} = props
    return (
        <Container>
            <ActionDropdown isBulk={isBulk} disabled={disabled} onSubmit={onSubmit}/>
            <CommonExportIcon data={data} columns={column}/>
            <FilterFilled />
        </Container>
    )
}

ExtraFilters.propTypes = {}

export default ExtraFilters